/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Utils.Array
 */

module.exports = {

    Matrix: require('./matrix'),

    Add: require('./Add'),
    AddAt: require('./AddAt'),
    BringToTop: require('./BringToTop'),
    CountAllMatching: require('./CountAllMatching'),
    Each: require('./Each'),
    EachInRange: require('./EachInRange'),
    FindClosestInSorted: require('./FindClosestInSorted'),
    GetAll: require('./GetAll'),
    GetFirst: require('./GetFirst'),
    GetRandom: require('./GetRandom'),
    MoveDown: require('./MoveDown'),
    MoveTo: require('./MoveTo'),
    MoveUp: require('./MoveUp'),
    NumberArray: require('./NumberArray'),
    NumberArrayStep: require('./NumberArrayStep'),
    QuickSelect: require('./QuickSelect'),
    Range: require('./Range'),
    Remove: require('./Remove'),
    RemoveAt: require('./RemoveAt'),
    RemoveBetween: require('./RemoveBetween'),
    RemoveRandomElement: require('./RemoveRandomElement'),
    Replace: require('./Replace'),
    RotateLeft: require('./RotateLeft'),
    RotateRight: require('./RotateRight'),
    SafeRange: require('./SafeRange'),
    SendToBack: require('./SendToBack'),
    SetAll: require('./SetAll'),
    Shuffle: require('./Shuffle'),
    SortByDigits: require('./SortByDigits'),
    SpliceOne: require('./SpliceOne'),
    StableSort: require('./StableSort'),
    Swap: require('./Swap')

};
